'use strict';

import { latLngAltToVector3, Layer } from './Layer';
import {Vector3} from "three";
import { Orbit360Viewer } from './Orbit360Viewer';

export class Orbit360 extends Layer {
    constructor (parent, data) {
        super(parent, data);

        return this.createLayer();
    }

    async createLayer() {
        this.data = await this.response;
        this.btn?.remove();
        const labels = [];

        const center = {lat: Number(config.localization.latitude), lng: Number(config.localization.longitude)};
        this.data.forEach(el => {
            if (el?.x && el?.z) {
                const vector = new Vector3(el.x, 0, el.z);
                vector.y = el.altitude;
                const labelScope = new Orbit360Viewer(el);
                labelScope.label.position.copy(vector);
                labels.push(labelScope.label);
            } else {
                const coords = {lat: el.lat, lng: el.lng};
                const vector = latLngAltToVector3(coords,center);
                vector.y = el.altitude;
                const labelScope = new Orbit360Viewer(el);
                labelScope.label.position.copy(vector);
                labels.push(labelScope.label);
            }
        });

        return labels;
    }

}


